module.exports = __webpack_public_path__ + "media/images/pic/meat-3-f86b976e6bc4197295ad4ea1bb8c6852.jpg";